export default {
  "nav.home": "Accueil",
  "nav.categories": "Catégories",
  "nav.articles": "Guides",
  "nav.faq": "FAQ",
  "nav.shopGuide": "Guide d'achat",

  "hero.eyebrow": "USFans Spreadsheet et Centre de Ressources",
  "hero.title": "USFans Spreadsheet — trouvez, explorez et comparez les ressources USFans",
  "hero.subtitle": "Trouvez des ressources organisées de la feuille de calcul USFans, des listes de créateurs, des avis, des guides d'expédition, des coupons et des comparaisons — le tout dans un hub facile à naviguer.",
  "hero.ctaPrimary": "USFans Spreadsheet",
  "hero.ctaSecondary": "Acheter maintenant",
  "hero.trust": "Ressource indépendante • Informations à jour • Axé sur la sécurité",
  "hero.searchPlaceholder": "Recherchez feuilles de calcul, créateurs, livraison, coupons, avis...",

  "categories.title": "Parcourir par catégorie",
  "categories.subtitle": "Accédez directement aux produits que vous recherchez dans la boutique principale.",
  "categories.dropdownLabel": "Sélectionnez une catégorie",
  "categories.view": "Voir la catégorie",

  "articles.title": "USFans Spreadsheet : guides et ressources",
  "articles.subtitle": "Lisez nos guides détaillés pour comprendre le fonctionnement des ressources de la feuille de calcul USFans, des listes de créateurs et des comparaisons.",
  "articles.readMore": "Lire le guide complet",

  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Des réponses rapides et pratiques sur les ressources de la feuille de calcul USFans.",

  "cta.title": "Prêt à explorer les ressources USFans ?",
  "cta.subtitle": "Explorez nos ressources de feuille de calcul USFans, guides, comparaisons et informations de sécurité — puis rendez-vous dans la boutique principale.",

  "footer.desc": "USFansLink est un centre de ressources indépendant avec des liens vers des feuilles de calcul USFans, des listes de créateurs, des avis, des guides d'expédition, des coupons et des comparaisons.",
  "footer.disclaimer": "USFansLink est une ressource d'information indépendante. Nous ne sommes affiliés à aucune marque sauf indication explicite.",
  "footer.rights": "Tous droits réservés.",
  "footer.explore": "Explorer",
  "footer.categories": "Catégories",
  "footer.language": "Langue",

  "category.shoes": "Chaussures",
  "category.hoodies": "Hoodies/Sweats",
  "category.tshirts": "T-shirts",
  "category.jackets": "Vestes",
  "category.pants": "Pantalons/Shorts",
  "category.headwear": "Couvre-chefs",
  "category.sets": "Ensembles",
  "category.underwear": "Sous-vêtements",
  "category.jersey": "Maillot",
  "category.accessories": "Accessoires",
  "category.bags": "Sacs",
  "category.belts": "Ceintures",
  "category.perfumes": "Parfums",
  "category.other": "Autres articles",

  "common.backHome": "Retour à l'accueil",
  "common.readArticle": "Lire l'article",
  "common.published": "Publié",
  "common.updated": "Mis à jour",
  "common.author": "Auteur",
  "common.readTime": "min de lecture",
  "common.onThisPage": "Sur cette page",
  "common.relatedResources": "Ressources liées",
  "common.quickAnswer": "Réponse rapide",
  "common.faqShort": "FAQ",
};